<div class="body_wrap dashboard_body">
  <!-- <div class="sticky-top sticky-offset">
    <div class="top_menu">
      <button mat-button class="d-md-none d-none">
        <img src="../../assets/images/menu.svg" />
      </button>
    </div>
  </div> -->
  <div class="dash_base">
    <app-progress-indicator
      *ngIf="isFavoriteGroupLoading || (activeGroupProperties?.totalCount && isGroupPropertyLoading)"
      [transparency]="0.5"
      text="Please wait while we load"
    ></app-progress-indicator>

    <div class="w-100">
      <section>
        <div class="container mt-40">
          <!-- WATCHLIST GROUPS SECTION -->

          <div
            class="whiteWrap"
            [hidden]="(!isGroupPropertyLoading && activeFavoriteGroup) || activeGroupProperties?.totalCount"
          >
            <div class="titleWrap">
              <h4 class="mt-1">Watchlist</h4>

              <div class="posButtonWrap float-right pl-3 pr-3">
                <button mat-flat-button color="primary" class="btn-prefix-icon" (click)="openPopUp('createGroup')">
                  <mat-icon> post_add </mat-icon> New Watchlist
                </button>
              </div>

              <div class="favBalance float-right pt-1">
                <b> {{ favUsageCount }} </b>/{{ favLimit }}
                <span class="text-secondary"> Properties Watched </span>
              </div>

              <mat-form-field class="w-50">
                <mat-label> Search </mat-label>
                <input
                  matInput
                  (keyup)="applyFilter($any($event.target).value, 'groups')"
                  autocomplete="off"
                  placeholder="
                      Search Name"
                />
              </mat-form-field>
            </div>
            <div class="wrap_body">
              <div class="mb-3">
                <div
                  class="flex_center fullHeight"
                  *ngIf="!isFavoriteGroupLoading && !(favoriteGroupDataSource$ | async)?.length"
                >
                  <div class="notFound text-center w-100">
                    <img class="img-fluid" width="60" src="~/../assets/images/notFound.svg" />
                    <h4>No watchlist found</h4>
                  </div>
                </div>

                <div class="row">
                  <div
                    class="col-lg-3 col-md-3 col-sm-6 col-12 py-2"
                    *ngFor="let propertyGroup of favoriteGroupDataSource$ | async; let i = index"
                  >
                    <app-followed-properties-group-card
                      [propertyGroup]="propertyGroup"
                      [followGroupNameList]="followGroupNameList"
                      [isGroupNameChangeInProgress]="isGroupNameUpdateInProgress"
                      [exportingInProgress]="exportingInProgress"
                      [isLoading]="
                        isGroupPropertyLoading &&
                        propertyGroup.id == followedPropertiesState.activeFavoriteGroupValue.id
                      "
                      [disabled]="isGroupPropertyLoading"
                      (exportData)="readyToExport('group', propertyGroup.id, propertyGroup.name)"
                      (click)="getPropertyList(propertyGroup)"
                      (deleteId)="deleteGroup(propertyGroup)"
                      (editName)="enableEditing(propertyGroup)"
                      (updateName)="updateGroupName(propertyGroup, i)"
                      (externalExportFile)="externalExport('favoriteGroup', propertyGroup.id)"
                    ></app-followed-properties-group-card>
                  </div>
                </div>
                <div class="row ml-0 mr-0">
                  <div class="col-lg-12 paginationWrap mt-2">
                    <mat-paginator
                      #groupPaginator
                      [pageSizeOptions]="[12, 24, 36]"
                      showFirstLastButtons
                    ></mat-paginator>
                  </div>
                </div>
                <div class="flex_center w-100" *ngIf="!favoriteGroupDataSource?.filteredData?.length">
                  <div class="notFound text-center noData">
                    <div>
                      <img class="img-fluid" width="60" src="~/../assets/images/notFound.svg" />
                      <h4>No search result found</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- WATCHLIST PROPERTIES SECTION -->

          <div class="whiteWrap" [hidden]="isGroupPropertyLoading || !activeFavoriteGroup">
            <div class="titleWrap mb-3">
              <h4 class="mt-1 mb-3">Watched properties</h4>
              <div class="row">
                <div class="col-lg-4 col-12">
                  <h5>
                    <button (click)="goBack()" mat-icon-button color="primary" class="backArrow float-left">
                      <mat-icon> arrow_back_ios </mat-icon>
                    </button>
                    <small>Watchlist Name : </small>
                    <b class="truncated oneLine"> {{ activeFavoriteGroup?.name }}</b>
                  </h5>
                </div>
                <!-- <mat-form-field class="w-50">
                <mat-label> Search Properties </mat-label>
                <input
                  matInput
                  (keyup)="applyFilter($any($event.target).value, 'properties')"
                  autocomplete="off"
                  placeholder="Search Address, Property Type, Owner Name"
                  [(ngModel)]="searchPropertyInput"
                />
              </mat-form-field> -->
                <div class="col-lg-8 col-12 d-flex justify justify-content-end">
                  <button
                    *ngIf="activeGroupProperties?.data?.length"
                    mat-button
                    color="primary"
                    class="mr-4 select-all-btn"
                    (click)="toggleSelectAll()"
                  >
                    {{ isAllSelected() ? 'Deselect All' : 'Select All' }}
                  </button>
                  <button
                    class="mr-4 select-all-btn"
                    *ngIf="!activeGroupProperties?.data?.length"
                    color="primary"
                    mat-button
                    [disabled]="!activeGroupProperties?.data?.length"
                  >
                    Select All
                  </button>
                  <div>
                    <div class="btn-group mr-3">
                      <button
                        type="button"
                        (click)="readyToExport('property')"
                        [disabled]="!selectedActiveGroupPropertyIdList.length"
                        class="btn proptech_btn pl-4 pr-1"
                        [pmx-progress-button]="exportingInProgress"
                      >
                        Export
                      </button>
                      <div
                        class="btn-group groupDropUpWrap"
                        ngbDropdown
                        role="group"
                        [autoClose]="true"
                        [placement]="'bottom-right'"
                      >
                        <button
                          mat-button
                          class="btn proptech_btn dropdown-toggle-split pl-3 pr-3"
                          ngbDropdownToggle
                          [matMenuTriggerFor]="bulkMatMenu"
                          [disabled]="!selectedActiveGroupPropertyIdList.length"
                          [matBadge]="selectedActiveGroupPropertyIdList.length || ''"
                        ></button>
                        <div class="dropdown-menu" ngbDropdownMenu>
                          <mat-menu #bulkMatMenu="matMenu" id="fldproplist_action" class="mt-0" xPosition="before">
                            <button mat-menu-item (click)="processToAnotherGroup('multiple', 'copy')">
                              <i class="fa fa-clone mr-1" aria-hidden="true"></i>
                              <span>Copy </span>
                            </button>
                            <button mat-menu-item (click)="processToAnotherGroup('multiple', 'move')">
                              <i class="fa fa-arrows-alt mr-1" aria-hidden="true"></i>
                              <span>Move</span>
                            </button>
                            <button mat-menu-item (click)="unFollowProperty('multiple')">
                              <i class="fa fa-trash-o mr-1" aria-hidden="true"></i>
                              <span>Delete</span>
                            </button>
                          </mat-menu>
                        </div>
                      </div>
                    </div>
                    <p class="text-secondary small mb-0 mt-1">
                      <i class="fa fa-info-circle" aria-hidden="true"></i>
                      Select one or more properties to export
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div [hidden]="!activeGroupProperties?.data?.length">
              <div class="row px-2">
                <div
                  class="col-lg-4 col-md-4 col-sm-6 col-12 py-2"
                  *ngFor="
                    let property of (followedPropertiesState.favoritePropertiesByGroup$ | async)?.data;
                    let i = index
                  "
                >
                  <app-property-card
                    [property]="property"
                    [actions]="actions"
                    [type]="'watchlist'"
                    [isSelected]="selectedActiveGroupPropertyIdList.includes(property.id)"
                    [isSelectable]="true"
                    (triggeredActionCopy)="processToAnotherGroup('single', 'copy', property)"
                    (triggeredActionMove)="processToAnotherGroup('single', 'move', property)"
                    (triggeredActionDelete)="unFollowProperty('single', property.id)"
                    (toggleSelectCard)="toggleSelect($event)"
                  >
                  </app-property-card>
                </div>
              </div>
              <mat-paginator
                #propertyPaginator
                [pageSizeOptions]="[9, 18, 27]"
                (page)="pageChange($event)"
                showFirstLastButtons
              ></mat-paginator>
            </div>

            <div class="flex_center w-100" *ngIf="!isGroupPropertyLoading && !activeGroupProperties?.data?.length">
              <div class="notFound text-center noData">
                <div>
                  <img class="img-fluid" width="60" src="~/../assets/images/notFound.svg" />
                  <h4>No watched properties found</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</div>
<!-- <app-create-watch-list-sheet *ngIf="createWatchListSheetActive"></app-create-watch-list-sheet> -->
